import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { ContentProvider } from "./context/ContentContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import About from "./components/About";
import Stats from "./components/Stats";
import Products from "./components/Products";
import Principles from "./components/Principles";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import DeliveryLogin from "./pages/DeliveryLogin";
import DeliveryDashboard from "./pages/DeliveryDashboard";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Features />
      <About />
      <Stats />
      <Products />
      <Principles />
      <Contact />
    </main>
    <Footer />
    <WhatsAppFloat />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/teslimat" element={<DeliveryLogin />} />
            <Route path="/teslimat/panel" element={<DeliveryDashboard />} />
          </Routes>
          <Toaster />
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
